<template>      
    <layout>

        <slot></slot>
                
        <v-navigation-drawer
            absolute
            permanent
            right
            class="mr-4 mt-10 d-none d-md-flex"
            height="288"
            width="200"
            style="top:64px"
        >
            <v-list class="grey lighten-5 py-0">
                <v-list-item
                    v-for="(item, index) in menuItems"
                    :key="index"
                    :to="item.route"
                    color="primary"                        
                    active-class="active"
                >
                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
                
        <v-bottom-navigation
            background-color="primary"
            height="48"
            absolute
            class="d-flex d-md-none"
        >
            <bottom-navigation></bottom-navigation>
        </v-bottom-navigation>
                      
        
    </layout>    
</template>

<script>
import { mapGetters } from 'vuex';
import BottomNavigation from '../FormProgress';
import Layout from '../layouts/App';

export default {
    components: {
        BottomNavigation,
        Layout
    },

    created: function () {
        this.initialize()
    },

    data: () => ({
        menuItems: [
            {title: "Student Data", route: '/registration/student-data' },
            {title: "Family Data", route: '/registration/family-data'},
            {title: "Medical Data", route: '/registration/health-data'},
            {title: "Other Data", route: '/registration/other-data'},
            {title: "Upload Documents", route: '/registration/documents'},
            {title: "Complete", route: '/registration/complete'},
        ],
        navigationMenus: [
            //{title: "Term Reports", icon: "mdi-file-certificate", route: '/term-reports'},
            {title: "Logout", icon: "mdi-logout", route: '/logout'},
        ],
        
        fab: false,
        hidden: true,
    }),

    

    computed: {
        ...mapGetters({
            schoolName: 'form/getSchoolName',
            user: 'auth/getUser',
        }),

        activeFab () {
          if(this.documentTop){
              return {color: this.primaryColor + ' ' + this.colorDarken, icon: 'mdi-chevron-down'};
          }
          else{
              return {color: this.primaryColor + ' ' + this.colorDarken, icon: 'mdi-chevron-up'}
          }
      },
    },

    methods: {
        quickScroll(){
          this.documentTop = !this.documentTop;
          if(this.documentTop){
              window.scrollTo(0, document.body.scrollHeight);
          }
      },

      initialize () {
          this.hidden = false;
      }
    }
}
</script>

<style scoped>
    ::v-deep .v-list .v-list-item {
        border-left: 2px solid #e5e5ee;
    }

    ::v-deep .v-list-item.v-list-item--link.theme--light{
        border-left: 0px;
    }

    ::v-deep .v-list .v-list-item--active {
        border-left-color: #2159b0;
    }

    ::v-deep #speed-dial {
        position: fixed;
        top: 64px;
    }

    ::v-deep .v-speed-dial__list{
        align-items: start;
    }    
    
</style>